module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_tick-725a2f5a9915faa6c6532497d2f3f0fa.svg";